<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title"><i class="el-icon-s-help"></i> 路由配置</div>
    <div class="main-shadow-box">
      <el-table :data="list" size="medium">
        <el-table-column prop="route" label="路由"></el-table-column>
        <el-table-column prop="img1CheckAlive" label="图1活体开关" align="center">
          <template v-slot="scope">
            <el-tag :type="scope.row.img1CheckAlive?'success':'danger'">
              {{ scope.row.img1CheckAlive?'开':'关' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="img2CheckAlive" label="图2活体开关" align="center">
          <template v-slot="scope">
            <el-tag :type="scope.row.img2CheckAlive?'success':'danger'">
              {{ scope.row.img2CheckAlive?'开':'关' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="compareMode" label="对比模式">
          <template v-slot="scope">
            <span v-if="scope.row.compareMode===1">生活照模式</span>
            <span v-else-if="scope.row.compareMode===2">证件照模式</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template v-slot="s">{{s.row.createTime | date}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="s">
            <el-button @click="openUpdate(s.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <edit-dialog :visible.sync="editVisible" :routeConfig="currentRouteConfig" @load="load"></edit-dialog>
  </div>
</template>
<script>
import editDialog from './update'

export default {
  components: {
    editDialog
  },
  data() {
    return {
      list: [],
      editVisible: false,
      currentRouteConfig: {}
    };
  },
  methods: {
    async load() {
      let res = await this.$request(this.$api.routeConfig.list());
      this.list = res
    },
    openUpdate(row){
      this.currentRouteConfig = {...row}
      this.editVisible = true
    }
  },
  mounted() {
    this.load()
  }
};
</script>
